import UPDayPickerDisplay from './UPDayPickerDisplay';

export default UPDayPickerDisplay;
